import {
    CREATE_SJFSERVER,
    RETRIEVE_SJFSERVER,
    RETRIEVESINGLE_SJFSERVER,
    UPDATE_SJFSERVER,
    DELETE_SJFSERVER,
  } from "../actions/type";
  const initialState = [];
  function SJFServersReducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case CREATE_SJFSERVER:
        return {data: state.data, payload};
      case RETRIEVE_SJFSERVER:
        state = (payload.error == 1)?initialState:payload;
        return {data: state, payload};
      case RETRIEVESINGLE_SJFSERVER:
        state = (payload.error == 1)?initialState:payload;
        return {data: state.data, payload};
      case UPDATE_SJFSERVER:
        return {data: state.data, payload};
      case DELETE_SJFSERVER:
        return {data: state.data, payload};
      default:
        return state;
    }
  };
  export {SJFServersReducer};